$('.js-mobile-header').each((index, element) => {
	let $component = $(element);
	let $page = $component.closest('.page');
	let $showMenuButton = $component.find('.js-burger');
	let $menu = $component.find('.js-header-menu');
	let $pageContent = $page.find('.js-page-content');
	let $closeMenuButton = $page.find('.js-close-menu-button');

	$component.on('header:menu:toggle', () => {
		if ($menu.hasClass('active')) {
			$menu.removeClass('active');
			$pageContent.removeClass('active');
			$component.removeClass('active');
		} else {
			$menu.addClass('active');
			$pageContent.addClass('active');
			$component.addClass('active');
		}
	});

	$component.on('header:menu:hide', () => {
		$menu.removeClass('active');
		$pageContent.removeClass('active');
		$component.removeClass('active');
	});

	$showMenuButton.on('click', (e) => {
		e.preventDefault();

		$component.trigger('header:menu:toggle');
	});

	$closeMenuButton.on('click', () => {
		$component.trigger('header:menu:hide');
	});

	$page.on('page:hide', () => {
		$component.trigger('header:menu:hide');
	});
});

export function initMobileHeader($page) {
	let $window = $(window);
	let $document = $(document);
	let $mobileHeader = $page.find('.js-mobile-header');
	let $progressBar = $mobileHeader.find('.mobile-header__progress');

	let windowHeight = $window.height();
	let documentHeight = $document.height() - windowHeight - 100;

	let init = () => {
		let scrollTop = $window.scrollTop();
		let progress = scrollTop / documentHeight * 100;

		$mobileHeader.toggleClass('is-fixed', scrollTop >= 50);
		$progressBar.css('width', `${progress}%`);
	};

	init();

	$window
		.off('.mobile-header')
		.on('scroll.mobile-header', () => {
			init();
		})
		.on('resize.mobile-header', () => {
			windowHeight = $window.height();
			documentHeight = $document.height() - windowHeight - 100;
		});
}
